const React = require("react");
const noop = require('mn-utils/noop');

const Ripple = require("../../Ripple");
const {Link} = require("../../../../router");

const ArrowRight = require("./svg/ArrowRight");

module.exports = ({index, className, link, onClick, ...props}) => {
  const C = (link || onClick) ? Ripple : 'div';
  const component = link ? Link : undefined;
  return (
    <C
      {...props}
      component={component}
      className={
        `w h70 layoutRow fhaS fvaC bxzBorderBox rlv fw7 f12 c2 tl lts0em td bgFAFAFA.hasBg
        (pt19|pr10|pb23|pl19|tc|f12|fw4)>1 (fw7)>1.bold (jcC)>.fhaS (crPointer).clickable
        (w26|hA|abs|sr8|st50%|xY-50%|dn)>.cursor
        (sr3):h>.cursor
        (c2)>a
        `
        + ((index + 1) % 2 === 0 ? ' hasBg' : '')
        + (link || onClick ? ` clickable` : '')
        + (className ? ` ${className}` : '')
      }
      href={link || undefined}
      onClick={onClick || noop}
    >
      {props.children}
      {(!!link || onClick) && (
        <Ripple className="cursor">
          <ArrowRight width={6} height={10} className="c73757A" />
        </Ripple>
      )}
    </C>
  )
}
